export const HEADER_LEVELS: (number | false)[] = [
  false, 1, 2, 3, 4, 5
];